'use client';

import type { NextPage } from 'next';
import styles from './sidebar-menu.module.scss';
import FooterSidebar from './components/FooterSidebar/FooterSidebar';
import ItemPrimary from './components/ItemPrimary/ItemPrimary';
import OpenItem from './components/OpenItem/OpenItem';
import { useCallback } from 'react';
import {
  sideBarData1,
  sideBarData2,
  sideBarData3,
  sideBarData4,
} from '@/data/sideBar.data';
import { SidebarMenuProps } from '@/types/header.types';
import SearchBar from '@/components/SearchBar/SearchBar';

const SidebarMenu: NextPage<SidebarMenuProps> = ({ onClose }) => {
  const handleBackdropClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose]
  );

  return (
    <div className={styles.sidebarmenu} onClick={handleBackdropClick}>
      <main className={styles.sidebarmenu1}>
        <div className={styles.searchWrapper}>
          <SearchBar variant="fullscreen" onResultSelect={onClose} />
        </div>
        <section className={styles.menucontent}>
          <OpenItem onClose={onClose} data={sideBarData1} />
          <OpenItem onClose={onClose} data={sideBarData2} />

          <ItemPrimary
            chevron="Off"
            state="Default"
            about="Charter Flights"
            chevron1="/img/header/arrowRight.svg"
            onClick={onClose}
            href="/charter"
          />
          <ItemPrimary
            chevron="Off"
            state="Default"
            about="Empty Leg Flights"
            chevron1="/img/header/arrowRight.svg"
            onClick={onClose}
            href="/empty-leg-flights"
          />
          <OpenItem onClose={onClose} data={sideBarData4} />
          {/* <ItemPrimary
            chevron="Off"
            state="Default"
            about="Jet Card"
            chevron1="/img/header/arrowRight.svg"
            onClick={onClose}
            href="/hera-jet-card-membership"
          /> */}
          <ItemPrimary
            chevron="Off"
            state="Default"
            about="Available Fleet"
            chevron1="/img/header/arrowRight.svg"
            onClick={onClose}
            href="/available-fleet"
          />
          <ItemPrimary
            chevron="Off"
            state="Default"
            about="Blog"
            chevron1="/img/header/arrowRight.svg"
            onClick={onClose}
            href="/blog"
          />
          <ItemPrimary
            chevron="Off"
            state="Default"
            about="Contacts"
            chevron1="/img/header/arrowRight.svg"
            onClick={onClose}
            href="/contact"
          />
        </section>
        <FooterSidebar />
      </main>
    </div>
  );
};

export default SidebarMenu;
